import DetailPanel from './DetailPanel.component';
import TabContent from './TabContent.component';

const DashboardContent = ({
  yacht,
  yachtID,
  activeTab,
  onTabChange,
  filters,
}) => (
  <DetailPanel yacht={yacht} activeTab={activeTab} onTabChange={onTabChange}>
    <TabContent activeTab={activeTab} yacht={yacht} yachtID={yachtID} filters={filters} />
  </DetailPanel>
);

export default DashboardContent;
